/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailConfirm
 */
export interface EmailConfirm {
    /**
     * Confirmation code
     * @type {string}
     * @memberof EmailConfirm
     */
    emailConfirmCode: string;
}

export function EmailConfirmFromJSON(json: any): EmailConfirm {
    return EmailConfirmFromJSONTyped(json, false);
}

export function EmailConfirmFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailConfirm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailConfirmCode': json['emailConfirmCode'],
    };
}

export function EmailConfirmToJSON(value?: EmailConfirm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailConfirmCode': value.emailConfirmCode,
    };
}

